/*
    Not Found View
    Extends ItemView
*/

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/not-found.hbs';

    var NotFoundView = Marionette.View.extend({
        template: Handlebars.compile(template),
        className : 'notFound',
        id : "ide-container",
        data : {},
        initialize: function(options){
            if (options){
                if (options.path){
                    this.data.path = options.path;
                }
                if (options.message){
                    this.data.message = options.message;
                }
            } else {
                this.data.default = true;
            }
        },
        templateContext: function(){
            return this.data;
        }
    });

    export default NotFoundView;

